import React from 'react'
import { Link, useLocation } from 'react-router-dom'

import { Tag } from '@fourthwall/components'
import type { components } from '@fourthwall/services/dist/schema'
import { isWebView } from '@fourthwall/utils'
import type { FromLocationState } from '@types'
import { reverse, routing } from '@utils/routing'

type Status =
  components['schemas']['com.fourthwall.app.offer.model.OfferXResponse.Public']['state']['status']

export type OfferLinkProps = {
  name: string
  label: string
  id?: string
  status: Status | string // currently it's typed as string in the response
}

export const OfferLink = ({ name, label, id, status }: OfferLinkProps) => {
  const location = useLocation()

  if (status === 'ARCHIVED') {
    return (
      <div style={{ display: 'inline-flex', alignItems: 'center' }}>
        <div>{name}</div>
        <div style={{ marginLeft: 8 }}>
          <Tag label="Archived" />
        </div>
      </div>
    )
  }

  // don't link to offer inside web view
  if (!id || isWebView()) {
    return name
  }

  const to = reverse(routing.products.all.product.self, { productId: id })
  const state: FromLocationState = { from: { label, location } }

  return (
    <Link to={to} state={state}>
      {name}
    </Link>
  )
}
